(function () {
  if (window.floofCartDrawerLoaded) return;

  window.floofCartDrawerLoaded = true;


  document.addEventListener('change', function (event) {
    const variantSelector = event.target.closest(
      '[data-floof-upsell-variant]'
    );

    if (
      !variantSelector ||
      variantSelector.tagName !== 'SELECT'
    ) {
      return;
    }

    const card = variantSelector.closest(
      '[data-floof-upsell-card]'
    );

    if (!card) return;

    const price = card.querySelector(
      '[data-floof-upsell-price]'
    );

    const selectedOption =
      variantSelector.selectedOptions[0];

    if (
      price &&
      selectedOption &&
      selectedOption.dataset.price
    ) {
      price.textContent =
        selectedOption.dataset.price;
    }
  });


  document.addEventListener('click', function (event) {
    const navigationButton = event.target.closest(
      '[data-floof-upsell-nav]'
    );

    if (navigationButton) {
      event.preventDefault();

      const section = navigationButton.closest(
        '[data-floof-upsell-source]'
      );

      const track = section
        ? section.querySelector(
            '[data-floof-upsell-track]'
          )
        : null;

      if (!track) return;

      const direction =
        navigationButton.dataset.floofUpsellNav === 'next'
          ? 1
          : -1;

      track.scrollBy({
        left: track.clientWidth * direction,
        behavior: 'smooth'
      });

      return;
    }


    const addButton = event.target.closest(
      '[data-floof-upsell-add]'
    );

    if (!addButton) return;

    event.preventDefault();

    addFloofUpsell(addButton);
  });


  async function addFloofUpsell(button) {
    const card = button.closest(
      '[data-floof-upsell-card]'
    );

    if (!card) return;

    const variantSelector = card.querySelector(
      '[data-floof-upsell-variant]'
    );

    if (
      !variantSelector ||
      !variantSelector.value
    ) {
      return;
    }

    const variantId =
      variantSelector.value;

    const upsellSection = button.closest(
      '[data-floof-upsell-source]'
    );

    const sourceProductId =
      upsellSection
        ? upsellSection.dataset.floofSourceProductId
        : '';

    const cartDrawer =
      document.querySelector(
        'cart-drawer'
      );

    if (!cartDrawer) return;

    button.disabled = true;
    button.textContent = 'ADDING...';

    try {
      const config =
        fetchConfig('javascript');

      config.headers[
        'X-Requested-With'
      ] = 'XMLHttpRequest';

      delete config.headers[
        'Content-Type'
      ];

      const formData =
        new FormData();

      formData.append(
        'id',
        variantId
      );

      formData.append(
        'quantity',
        '1'
      );

      if (sourceProductId) {
        formData.append(
          'properties[_floof_upsell_source]',
          sourceProductId
        );
      }

      formData.append(
        'sections',
        cartDrawer
          .getSectionsToRender()
          .map(function (section) {
            return section.id;
          })
      );

      formData.append(
        'sections_url',
        window.location.pathname
      );

      cartDrawer.setActiveElement(
        button
      );

      config.body = formData;

      const response =
        await fetch(
          window.routes.cart_add_url,
          config
        );

      const data =
        await response.json();

      if (
        !response.ok ||
        data.status
      ) {
        throw new Error(
          data.description ||
          data.message ||
          'Unable to add product.'
        );
      }

      if (
        typeof publish === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined'
      ) {
        publish(
          PUB_SUB_EVENTS.cartUpdate,
          {
            source: 'floof-cart-upsell',
            productVariantId: variantId,
            cartData: data
          }
        );
      }

      cartDrawer.renderContents(
        data
      );

    } catch (error) {
      console.error(
        'Floofland cart upsell error:',
        error
      );

      button.disabled = false;
      button.textContent =
        'TRY AGAIN';
    }
  }
})();